import { createReducer, on } from '@ngrx/store';
import { AuthActions } from './auth.actions';
import { initialAuthState } from './auth.state';

const getInitialToken = (): string | null => {
  if (typeof window !== 'undefined') {
    return localStorage.getItem('accessToken');
  }
  return null;
};

export const authReducer = createReducer(
  {
    ...initialAuthState,
    token: getInitialToken(),
    isAuthenticated: !!getInitialToken(),
  },

  on(AuthActions.login, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(AuthActions.loginSuccess, (state, { message, token }) => ({
    ...state,
    message,
    token,
    loading: false,
    error: null,
    isAuthenticated: true,
  })),

  on(AuthActions.loginFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(AuthActions.loginAdmin, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(AuthActions.loginAdminSuccess, (state, { message, token }) => ({
    ...state,
    message,
    token,
    loading: false,
    error: null,
    isAuthenticated: true,
  })),

  on(AuthActions.loginAdminFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(AuthActions.loginMinalocUsers, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(AuthActions.loginMinalocUsersSuccess, (state, { message, token }) => ({
    ...state,
    message,
    token,
    loading: false,
    error: null,
    isAuthenticated: true,
  })),

  on(AuthActions.loginMinalocUsersFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(AuthActions.register, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(AuthActions.registerSuccess, (state, { message }) => ({
    ...state,
    message,
    loading: false,
    error: null,
    isAuthenticated: true,
  })),

  on(AuthActions.registerFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(AuthActions.logout, (state) => ({
    ...state,
    loading: true,
  })),

  on(AuthActions.logoutSuccess, () => ({
    ...initialAuthState,
  })),

  on(AuthActions.getCurrentUser, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(AuthActions.getCurrentUserSuccess, (state, { user }) => ({
    ...state,
    user,
    loading: false,
    error: null,
    isAuthenticated: true,
  })),

  on(AuthActions.getCurrentUserFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
    isAuthenticated: false,
  })),

  on(AuthActions.clearError, (state) => ({
    ...state,
    error: null,
  })),

  on(AuthActions.changePassword, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(AuthActions.changePasswordSuccess, (state, { message }) => ({
    ...state,
    message,
    loading: false,
    error: null,
  })),

  on(AuthActions.changePasswordFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
